import { render, staticRenderFns } from "./venueInfo.vue?vue&type=template&id=3cef466d&scoped=true"
import script from "./venueInfo.vue?vue&type=script&lang=js"
export * from "./venueInfo.vue?vue&type=script&lang=js"
import style0 from "./venueInfo.vue?vue&type=style&index=0&id=3cef466d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef466d",
  null
  
)

export default component.exports